import React, { FC } from 'react';
import styled from 'styled-components';

import { KeyTextObj } from '~src/interfaces/translation.interface';
import SvgIcon, { SvgIconName } from '~src/shared/SvgIcon';

export interface IconTextMenuItemProps {
  text: KeyTextObj;
  icon?: SvgIconName;
  arrow?: boolean;
}

const Title = styled.div`
  margin-left: 10px;
  margin-right: 10px;
  color: ${({ theme }) => theme.baseBlue.a6};
  font-size: 15px;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid ${({ theme }) => theme.black.a1};
  .iconDropDownArrow {
    transform: rotate(-90deg);
  }
  &:hover ${Title} {
    color: ${({ theme }) => theme.white.a10};
  }
`;

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const IconTextMenuItem: FC<IconTextMenuItemProps> = React.memo(({ text, icon, arrow }) => (
  <Wrapper>
    <InfoContainer>
      {icon && <SvgIcon name={icon} width={25} />}
      <Title data-translation={text.key}>{text.txt}</Title>
    </InfoContainer>
    {arrow && <SvgIcon name="iconDropDownArrow" width={10} />}
  </Wrapper>
));

export default IconTextMenuItem;
